import React, { useState, useEffect } from 'react';

import productServices from '../../../../../services/admFin/productServices';

import { Dots } from "react-activity";

import Popup from '../../../../../components/Popup';
import Input from '../../../../../components/Input';
import { FaCube } from 'react-icons/fa';

export default function PopupNewProduct(props) {
    const [auxInfos, setAuxInfos] = useState({});
    const [name, setName] = useState("");
    const [costCenter, setCostCenter] = useState("");
    const [billsPlan, setBillsPlan] = useState("");
    const [type, setType] = useState("");
    const [category, setCategory] = useState("");
    const [quantity, setQuantity] = useState(0);
    const [criticalQuantity, setCriticalQuantity] = useState(0);
    const [commercialUnitValue, setCommercialUnitValue] = useState(0);
    const [commercialUnit, setCommercialUnit] = useState("");
    const [NCMCode, setNCMCode] = useState("");
    const [ICMSOrigin, setICMSOrigin] = useState("Nacional");
    const [ICMSTaxSituation, setICMSTaxSituation] = useState("Tributada pelo Simples Nacional com permissão de crédito");
    const [PISTaxSituation, setPISTaxSituation] = useState("Outras operações de saída");
    const [CONFINSTaxSituation, setCONFINSTaxSituation] = useState("Outras operações de saída");
    const [CFOP, setCFOP] = useState("");
    const [CEAN, setCEAN] = useState("");
    const [CEST, setCEST] = useState("");
    const [CEANTrib, setCEANTrib] = useState("");
    const [fetching, setFetching] = useState(false);

    useEffect(() => {
        readInfoNewProduct();
    }, []);

    useEffect(() => {
        if (props.data && props.data.nome) {
            setName(props.data.nome);
            if(props.data.centro_de_custo)
                setCostCenter(props.data.centro_de_custo.nome);
            if(props.data.plano_de_contas)
                setBillsPlan(props.data.plano_de_contas.nome);
            if(props.data.tipo !== undefined)
                setType(productServices.productTypes.find(item => item[0] === props.data.tipo)[1]);
            if(props.data.categoria !== undefined)
                setCategory(productServices.productCategories.find(item => item[0] === props.data.categoria)[1]);
            setQuantity(props.data.quantidade);
            setCriticalQuantity(props.data.quantidade_critica);

            setCommercialUnitValue(props.data.valor_unitario_comercial);
            const commUnit = productServices.tipos_unidade.find(item => item[0] === props.data.unidade_comercial);
            setCommercialUnit(commUnit ? commUnit[1] : props.data.unidade_comercial);
            setNCMCode(props.data.codigo_ncm);
            setICMSOrigin(productServices.tipos_icms_origem.find(item => item[0] === props.data.icms_origem)[1]);

            const icmsST = productServices.tipos_icms_situacao_tributaria.find(item => item[0] == toString(props.data.icms_situacao_tributaria));
            if(icmsST)
                setICMSTaxSituation(icmsST[1]);
            
            const pisST = productServices.tipos_pis_cofins_situacao_tributaria.find(item => item[0] === props.data.pis_situacao_tributaria);
            if(pisST)
                setPISTaxSituation(pisST[1]);
            
            const cofinsST = productServices.tipos_pis_cofins_situacao_tributaria.find(item => item[0] === props.data.cofins_situacao_tributaria);
            if(cofinsST)
                setCONFINSTaxSituation(cofinsST[1]);

            
            setCFOP(props.data.CFOP);
            setCEAN(props.data.cEAN);
            setCEST(props.data.CEST);
            setCEANTrib(props.data.cEANTrib);
        } else
            cleanStates();
    }, [props.data]);

    async function readInfoNewProduct() {
        const response = await productServices.getInfoNewProduct();
        if (response.status === 200) {
            setAuxInfos(response.data);
        } else
            alert("Erro ao ler informações auxiliares, tente novamente!");
    }

    async function createProduct() {
        /* if(type === "Venda" && NCMCode.length != 8){
            alert("Código ncm deve ter 8 dígitos.");
            return;
        } */
        if (name && costCenter && billsPlan && type && category && quantity && criticalQuantity && commercialUnitValue && commercialUnit && ICMSOrigin && ICMSTaxSituation && PISTaxSituation && CONFINSTaxSituation) {
            setFetching(true);
            let commUnit = productServices.tipos_unidade.find(item => item[1] === commercialUnit);
            if(!commUnit)
                commUnit = commercialUnit;
            else
                commUnit = commUnit[0];
            const response = await productServices.postProduct(
                name,
                auxInfos.centros_de_custo.find(item => item.nome === costCenter).id,
                auxInfos.planos_de_contas.find(item => item.nome === billsPlan).id,
                productServices.productTypes.find(item => item[1] === type)[0],
                productServices.productCategories.find(item => item[1] === category)[0],
                quantity,
                criticalQuantity,
                commercialUnitValue,
                commUnit,
                NCMCode,
                productServices.tipos_icms_origem.find(item => item[1] === ICMSOrigin)[0],
                productServices.tipos_icms_situacao_tributaria.find(item => item[1] === ICMSTaxSituation)[0],
                productServices.tipos_pis_cofins_situacao_tributaria.find(item => item[1] === PISTaxSituation)[0],
                productServices.tipos_pis_cofins_situacao_tributaria.find(item => item[1] === CONFINSTaxSituation)[0],
                CFOP,
                CEST,
                CEAN,
                CEANTrib
            );
            setFetching(false);
            if (response.status === 201) {
                if (props.onCreate) props.onCreate(response.data);
                props.setVisibility(false);
                cleanStates();
            } else
                alert("Erro ao criar produto, tente novamente!");
        } else
            alert("Preencha os dados obrigatórios*");
    }

    async function updateProduct() {
        /* if(type === "Venda" && NCMCode.length != 8){
            alert("Código ncm deve ter 8 dígitos.");
            return;
        } */
        if (name && costCenter && billsPlan && type && category && quantity && criticalQuantity && commercialUnitValue && commercialUnit && ICMSOrigin && ICMSTaxSituation && PISTaxSituation && CONFINSTaxSituation) {
            setFetching(true);
            const commUnit = productServices.tipos_unidade.find(item => item[1] === commercialUnit);
            const response = await productServices.patchProduct(
                props.data.id,
                name,
                auxInfos.centros_de_custo.find(item => item.nome === costCenter).id,
                auxInfos.planos_de_contas.find(item => item.nome === billsPlan).id,
                productServices.productTypes.find(item => item[1] === type)[0],
                productServices.productCategories.find(item => item[1] === category)[0],
                quantity,
                criticalQuantity,
                commercialUnitValue,
                commUnit ? commUnit[0] : commercialUnit,
                NCMCode,
                productServices.tipos_icms_origem.find(item => item[1] === ICMSOrigin)[0],
                productServices.tipos_icms_situacao_tributaria.find(item => item[1] === ICMSTaxSituation)[0],
                productServices.tipos_pis_cofins_situacao_tributaria.find(item => item[1] === PISTaxSituation)[0],
                productServices.tipos_pis_cofins_situacao_tributaria.find(item => item[1] === CONFINSTaxSituation)[0],
                CFOP,
                CEST,
                CEAN,
                CEANTrib
            );
            setFetching(false);
            if (response.status === 200) {
                if (props.onUpdate) props.onUpdate(response.data);
                props.setVisibility(false);
            } else
                alert("Erro ao editar produto, tente novamente!");
        } else
            alert("Preencha os dados obrigatórios*");
    }

    function cleanStates() {
        setName("");
        setCostCenter("");
        setBillsPlan("");
        setType("");
        setCategory("");
        setQuantity(0);
        setCriticalQuantity(0);
        setCommercialUnitValue(0);
        setCommercialUnit("");
        setNCMCode("");
        setICMSOrigin("Nacional");
        setICMSTaxSituation("Tributada pelo Simples Nacional com permissão de crédito");
        setPISTaxSituation("Outras operações de saída");
        setCONFINSTaxSituation("Outras operações de saída");
        setCFOP("");
        setCEAN("");
        setCEST("");
        setCEANTrib("");
    }

    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            icon={<FaCube />}
            tittle="Novo produto"
        >
            <form>
                <Input
                    label="Nome*"
                    placeholder="Insira aqui o nome do produto"
                    id='popup-new-product-name'
                    onChange={(event) => setName(event.target.value)}
                    value={name}
                />
                <Input
                    label="Centro de custo*"
                    type='select'
                    options={auxInfos.centros_de_custo ? auxInfos.centros_de_custo.map(item => item.nome) : []}
                    id='popup-new-product-cost-center'
                    onChange={(event) => setCostCenter(event.target.value)}
                    value={costCenter}
                />
                <Input
                    label="Plano de contas*"
                    type='select'
                    options={auxInfos.planos_de_contas ? auxInfos.planos_de_contas.map(item => item.nome) : []}
                    id='popup-new-product-bills-plan'
                    onChange={(event) => setBillsPlan(event.target.value)}
                    value={billsPlan}
                />
                <Input
                    label="Tipo*"
                    type='select'
                    options={productServices.productTypes.map(item => item[1])}
                    noFilterOptions={productServices.productTypes.find(item => item[1] === type) ? true : false}
                    id='popup-new-product-type'
                    onChange={(event) => setType(event.target.value)}
                    value={type}
                />
                <Input
                    label="Categoria*"
                    type='select'
                    options={productServices.productCategories.map(item => item[1])}
                    noFilterOptions={productServices.productCategories.find(item => item[1] === category) ? true : false}
                    id='popup-new-product-category'
                    onChange={(event) => setCategory(event.target.value)}
                    value={category}
                />
                <div className="line">
                    <Input
                        label="Quantidade*"
                        type='number'
                        id='popup-new-product-quantity'
                        onChange={(event) => setQuantity(event.target.value)}
                        value={quantity}
                    />
                    <Input
                        label="Quantidade crítica*"
                        type='number'
                        id='popup-new-product-critical-quantity'
                        onChange={(event) => setCriticalQuantity(event.target.value)}
                        value={criticalQuantity}
                    />
                </div>
                <Input
                    label="Valor unitario comercial*"
                    type='number'
                    id='popup-new-product-commercial-unit-value'
                    onChange={(event) => setCommercialUnitValue(event.target.value)}
                    value={commercialUnitValue}
                />
                <Input
                    label="Unidade comercial*"
                    type='select'
                    options={productServices.tipos_unidade.map(item => item[1])}
                    noFilterOptions
                    id='popup-new-product-commercial-unit'
                    onChange={(event) => setCommercialUnit(event.target.value)}
                    value={commercialUnit}
                />

                <Input
                    label="Código NCM"
                    placeholder="Insira aqui o código NCM do produto"
                    id='popup-new-product-ncm-code'
                    onChange={(event) => setNCMCode(event.target.value)}
                    value={NCMCode}
                />
                <Input
                    label="Código CFOP"
                    placeholder="Insira aqui o código CFOP do produto"
                    id='popup-new-product-cfop-code'
                    onChange={(event) => setCFOP(event.target.value)}
                    value={CFOP}
                />
                <Input
                    label="Código CEST"
                    placeholder="Insira aqui o código CEST do produto"
                    id='popup-new-product-cest-code'
                    onChange={(event) => setCEST(event.target.value)}
                    value={CEST}
                />
                <Input
                    label="Código CEAN"
                    placeholder="Insira aqui o código CEAN do produto"
                    id='popup-new-product-cean-code'
                    onChange={(event) => setCEAN(event.target.value)}
                    value={CEAN}
                />
                <Input
                    label="Código CEANTrib"
                    placeholder="Insira aqui o código CEANTrib do produto"
                    id='popup-new-product-ceantrib-code'
                    onChange={(event) => setCEANTrib(event.target.value)}
                    value={CEANTrib}
                />
                {
                    type === "Venda" ?
                    <>
                        <Input
                            label="Origem ICMS*"
                            type='select'
                            options={productServices.tipos_icms_origem.map(item => item[1])}
                            noFilterOptions
                            id='popup-new-product-icms-origin'
                            onChange={(event) => setICMSOrigin(event.target.value)}
                            value={ICMSOrigin}
                        />
                        <Input
                            label="Situação tributária - ICMS*"
                            type='select'
                            options={productServices.tipos_icms_situacao_tributaria.map(item => item[1])}
                            noFilterOptions
                            id='popup-new-product-icms-tax-situation'
                            onChange={(event) => setICMSTaxSituation(event.target.value)}
                            value={ICMSTaxSituation}
                        />
                        <Input
                            label="Situação tributária - PIS*"
                            type='select'
                            options={productServices.tipos_pis_cofins_situacao_tributaria.map(item => item[1])}
                            noFilterOptions
                            id='popup-new-product-pis-tax-situation'
                            onChange={(event) => setPISTaxSituation(event.target.value)}
                            value={PISTaxSituation}
                        />
                        <Input
                            label="Situação tributária - CONFINS*"
                            type='select'
                            options={productServices.tipos_pis_cofins_situacao_tributaria.map(item => item[1])}
                            noFilterOptions
                            id='popup-new-product-confins-tax-situation'
                            onChange={(event) => setCONFINSTaxSituation(event.target.value)}
                            value={CONFINSTaxSituation}
                        />
                    </>
                    :
                    null
                }

                <button
                    type="button"
                    className="blue"
                    onClick={() => fetching ? alert("Um envio já está em andamento.") : (props.data && props.data.id ? updateProduct() : createProduct())}
                >
                    {
                        fetching ?
                            <Dots />
                            : (props.data && props.data.id ? "Salvar" : "Adicionar")
                    }
                </button>
            </form>
        </Popup>
    )
}